import React, { useEffect } from 'react';

const VendorForm = () => {
  useEffect(() => {
    // Check if script already exists to avoid duplicates
    const scriptId = 'fillout-embed-script';
    let script = document.getElementById(scriptId);

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = "https://server.fillout.com/embed/v1/";
      script.async = true;
      document.body.appendChild(script);
    }

    // Cleanup isn't strictly necessary for this embed script, 
    // but we ensure the script is available when the component mounts.
  }, []);

  return (
    <div className="w-full max-w-2xl mx-auto overflow-hidden rounded-sm shadow-[0_10px_30px_rgba(75,31,36,0.05)] border border-padua-border/30 bg-white">
      <div 
        style={{ width: '100%', height: '500px' }} 
        data-fillout-id="3m4ojCuHRqus" 
        data-fillout-embed-type="standard" 
        data-fillout-inherit-parameters 
        data-fillout-dynamic-resize
      ></div>
    </div>
  );
};

export default VendorForm;